<h1 mat-dialog-title>Hello!</h1>
<mat-dialog-content>
    <p>What should I call you?</p>

    <div *ngFor="let option of data.options" [style.margin-top.px]="10">
        <button (click)="setPreferrence(option)" [style.width.%]="100" mat-stroked-button data-cy="greeting-value-btn">{{ option.value }}</button>
    </div>
</mat-dialog-content>
